import { render } from "./EmployeesOnLeaveConfigModal.vue?vue&type=template&id=3381035e&scoped=true"
import script from "./EmployeesOnLeaveConfigModal.vue?vue&type=script&lang=js"
export * from "./EmployeesOnLeaveConfigModal.vue?vue&type=script&lang=js"

import "./EmployeesOnLeaveConfigModal.vue?vue&type=style&index=0&id=3381035e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3381035e"]])

export default __exports__